import React from "react";
// import WaliPayHeader from "./WalipayHeader";
import Tab from 'react-bootstrap/Tab';

export const Enterprise: React.FC = () => {
    return (
        <></>
    )
}